import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from "axios";
import Header from './Header';
import Footer from './Footer';
import FlashMessage from './FlashMessage';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import debounce from 'lodash.debounce';
import { API_URL, BASE_URL } from './Config';
import config from "./common/Config";
import Swal from 'sweetalert2';
import { setTableWidths, getTableWidths } from "../data/postAPi";
import CommonDatePicker from './datepicker/CommonDatePicker';
import "./css/custom-filter.css";

const OpenTrips = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  // Remove openTrips state since we're using server-side processing
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [options, setOptions] = useState([]);
  const [vehicles, setSelectedVehicles] = useState('');
  const modalRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  let [tripid, setTripid] = useState('');
  const [flashMessage, setFlashMessage] = useState(null);
  const accessToken = localStorage.getItem('accessToken');
  const [colWidths, setColWidths] = useState([60, 120, 120, 150, 150, 150, 120, 120]);
  const userId = localStorage.getItem("userId");
  const tableName = "openTripsTable";
  const [dates, setDates] = useState(null); // Add this state

  // Helper function to format date as YYYY-MM-DD without timezone issues
  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Add this handler function
  const handleDateRangeChange = (value) => {
    setDates(value);

    if (value && value[0] && value[1]) {
      // Use exact dates selected by user (no month manipulation)
      const startDate = new Date(value[0]);
      const endDate = new Date(value[1]);

      // Use local date formatting to avoid timezone issues
      const newFromDate = formatDateToYYYYMMDD(startDate);
      const newToDate = formatDateToYYYYMMDD(endDate);

      console.log('Setting new dates:', { newFromDate, newToDate });
      setFromDate(newFromDate);
      setToDate(newToDate);

      // Force DataTable reload with new dates after state update
      setTimeout(() => {
        if ($.fn.DataTable.isDataTable('#openTripsTable')) {
          console.log('Reloading DataTable with new dates');
          $('#openTripsTable').DataTable().ajax.reload();
        }
      }, 100);
    } else {
      setFromDate('');
      setToDate('');

      // Force DataTable reload with empty dates
      setTimeout(() => {
        if ($.fn.DataTable.isDataTable('#openTripsTable')) {
          $('#openTripsTable').DataTable().ajax.reload();
        }
      }, 100);
    }
  };
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;

  function startResizing(index, e) {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];
    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }

  useEffect(() => {
    async function fetchWidths() {
      try {
        const res = await getTableWidths(userId, tableName);
        if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
          setColWidths(res.data.widths);
        } else {
          setColWidths([60, 120, 120, 150, 150, 150, 120, 120]);
        }
      } catch (e) {
        setColWidths([60, 120, 120, 150, 150, 150, 120, 120]);
      }
    }
    fetchWidths();
  }, []);

  useEffect(() => {
    async function fetchVehicleOptions() {
      try {
        const response = await axios.post(
          `${config.API_URL}/get-vehicles_web`,
          {},
          {
            headers: {
              authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (!response.data || !response.data.data || !Array.isArray(response.data.data)) {
          throw new Error('Invalid response format or empty vehicle array');
        }

        const formattedOptions = response.data.data.map(item => ({
          key: `${item.modelName}`,
          value: item.vehicleId,
        }));

        setOptions(formattedOptions);
      } catch (error) {
        console.error('Error fetching vehicle options:', error);
      }
    }

    fetchVehicleOptions();
  }, []);

  const updateVehicleInfo = async () => {
    let vehiclesID = `${vehicles}`;
    if (!vehiclesID) {
      Swal.fire({
        title: 'Error',
        text: 'Please Select order.',
        icon: 'error',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    } else {
      const formOrder = new FormData();
      formOrder.append('tripId', tripid);
      formOrder.append('vehicle_id', vehiclesID);
      try {
        const res = await fetch(`${config.API_URL}/update_trip_vehicle`, {
          method: 'POST',
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formOrder,
        });
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await res.json();
        // Reload the DataTable
        if ($.fn.DataTable.isDataTable('#openTripsTable')) {
          $('#openTripsTable').DataTable().ajax.reload();
        }
        Swal.fire({
          title: 'Success',
          text: 'vehicle updated successful!.',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } catch (err) {
        console.log(err.message);
      }
    }
  };

  const handleCloseMessage = () => {
    setFlashMessage(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const fetchData = async () => {
    // Initialize or reload the DataTable
    if ($.fn.DataTable.isDataTable('#openTripsTable')) {
      $('#openTripsTable').DataTable().ajax.reload();
    } else {
      // If DataTable is not initialized, trigger the useEffect that initializes it
      // This will happen automatically when the component mounts
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    // Remove fetchData() here, let the date picker handle it
    // fetchData();
  }, [fromDate, toDate, selectedRole]);

  // Remove this useEffect since we removed openTrips state

  const viewVechMdl = (userId) => {
    setTripid(userId);
    if (modalRef.current) {
      const modal = new window.bootstrap.Modal(modalRef.current);
      modal.show();
    }
  };

  $(document).off('click', '#openTripsTable .mdlBtn').on('click', '#openTripsTable .mdlBtn', function () {
    const userId = $(this).data('id');
    viewVechMdl(userId);
  });

  useEffect(() => {
    console.log('DataTable useEffect triggered with dates:', { fromDate, toDate });

    // Destroy existing table if it exists
    if ($.fn.DataTable.isDataTable('#openTripsTable')) {
      $('#openTripsTable').DataTable().destroy();
    }

    const table = $('#openTripsTable').DataTable({
      serverSide: true,
      processing: true,
      paging: true,
      searching: true,
      ordering: false,
      autoWidth: false,
      pageLength: 50,
      lengthMenu: [25, 50, 100, 200],
      language: {
        paginate: { first: 'First', last: 'Last', next: 'Next', previous: 'Previous' },
        search: 'Search:',
        processing: 'Loading...',
      },
      ajax: function (data, callback) {
        console.log('DataTable AJAX called with dates:', { fromDate, toDate });
        const formData = new FormData();
        formData.append('searchByFromdate', fromDate);
        formData.append('searchByTodate', toDate);
        formData.append('draw', data.draw);
        formData.append('start', data.start);
        formData.append('length', data.length);
        formData.append('role', selectedRole);

        fetch(`${config.API_URL}/get_trip_list`, {
          method: 'POST',
          headers: { authorization: `Bearer ${accessToken}` },
          body: formData
        })
          .then(res => res.json())
          .then(json => {
            callback({
              draw: data.draw,
              recordsTotal: json.recordsTotal,
              recordsFiltered: json.recordsFiltered,
              data: json.data
            });
          })
          .catch(err => {
            console.error('Error fetching trips:', err);
            callback({ draw: data.draw, recordsTotal: 0, recordsFiltered: 0, data: [] });
          });
      },
      columns: [
        { data: null, width: colWidths[0] + 'px' },
        { data: 'date', width: colWidths[1] + 'px' },
        {
          data: 'trip_number',
          width: colWidths[2] + 'px',
          render: (data, type, row) =>
            `<a href="${BASE_URL}/open_trips/trip_summary/${row.id}">${row.trip_number}</a>`
        },
        { data: 'driver', width: colWidths[3] + 'px' },
        { data: 'vehicle', className: "text-center", width: colWidths[4] + 'px' },
        { data: 'route_number', width: colWidths[5] + 'px' },
        { data: 'status', className: "text-center", width: colWidths[6] + 'px' },
        {
          data: null,
          width: colWidths[7] + 'px',
          render: (data, type, row) =>
            `<button class="change-vehicl-btn mdlBtn" data-id="${row.id}">Change Vehicle</button>`
        }
      ],
      headerCallback: function (thead, data, start, end, display) {
        $(thead).find('th').each(function (index) {
          if (index < colWidths.length - 1) {
            $(this).css({
              'position': 'relative',
              'user-select': 'none',
              'width': colWidths[index] + 'px'
            });

            if (!$(this).find('.th-resizer').length) {
              $(this).append(`
                <div class="th-resizer" 
                     data-column-index="${index}"
                     style="position: absolute; right: -2px; top: 0; width: 5px; height: 100%; cursor: col-resize; z-index: 999; user-select: none; background-color: transparent;"
                     title="Drag to resize column">
                </div>
              `);
            }
          }
        });

        $(thead).off('mousedown', '.th-resizer').on('mousedown', '.th-resizer', function (e) {
          const index = parseInt($(this).data('column-index'));
          startResizing(index, e);
        });
      },
      drawCallback: function (settings) {
        var api = this.api();
        var startIndex = api.page.info().start;
        api.column(0, { page: 'current' }).nodes().each(function (cell, i) {
          cell.innerHTML = startIndex + i + 1;
        });
      }
    });

    return () => {
      if (table && typeof table.destroy === 'function') {
        table.destroy();
      }
    };
  }, [fromDate, toDate, selectedRole, accessToken]);

  const resizerStyles = `
    .th-resizer:hover {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }
    .resizable-header {
      position: relative;
      user-select: none;
    }
  `;

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = resizerStyles;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  return (
    <div>
      <Header />

      <nav className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i></a>
              <span className="last-crumb">Open Trips</span>
            </div>
          </div>
        </div>
      </nav>

      <div className="main-container position-relative">
        <div className="container-fluid">
          <div className="row" >
            <div className="col-12 col-lg-12 col-sm-12">
              <div className="dashboard">
                <div className="row open-trip-filter-row">
                  <div className="d-flex">
                    <CommonDatePicker
                      value={fromDate && toDate ? [new Date(fromDate), new Date(toDate)] : null}
                      onChange={val => {
                        if (val && val[0] && val[1]) {
                          // Use local date values to avoid timezone issues
                          const startDate = val[0];
                          const endDate = val[1];
                          const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
                          setFromDate(formatDate(startDate));
                          setToDate(formatDate(endDate));
                        } else {
                          setFromDate('');
                          setToDate('');
                        }
                      }}
                      showOneCalendar
                      format="yyyy-MM-dd"
                      character=" - "
                      className="dashdate mt-1"
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div class="dashboard">
                  <div className="verical-scrl-wrapper open-trip" id="style-3">
                    <table className="table table-bordered dataTable resizable" id="openTripsTable">
                      <thead>
                        <tr>
                          {["Sr.No.", "Date", "Trip ID", "Driver", "Vehicle", "Route", "Status", "Action"].map((header, idx) => (
                            <th
                              key={header}
                              className="resizable-header"
                              style={{
                                width: colWidths[idx],
                                minWidth: 50,
                                position: "relative",
                                padding: "8px"
                              }}
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      <div ref={modalRef} className="modal fade" id="vehicleMdl" aria-hidden="true" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Vehicle</h5>
              <button type="button" className="btn-close" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <select value={vehicles} onChange={(e) => setSelectedVehicles(e.target.value)} className="datatable-selector form-control" name="driver_list" id="driver_list" style={{ marginRight: "15px" }} >
                <option value="">Select a vehicles</option>
                {options.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.key}
                  </option>
                ))}
              </select>
            </div>
            <div className="modal-footer">
              <button type="button" className="common-closebtn" data-bs-dismiss="modal" >Close</button>
              <button type="button" className="float-right-btn common-popup-btn" data-bs-dismiss="modal" onClick={updateVehicleInfo}  >Submit changes</button>
            </div>
          </div>
        </div>
      </div>
      <FlashMessage
        message={flashMessage?.message}
        type={flashMessage?.type}
        onClose={handleCloseMessage}
      />
    </div>
  );
};

export default OpenTrips;